export default [
  /*************APP管理**************************************/
  {
    path: '/market/appManage/schoolSignUp',
    name: 'market_schoolSignUp',
    meta: {
      title: '校园报名',
      pageId: 'schoolSignUp',
      pageName: '校园报名',
      parentId: 'appManage',
      parentName: 'APP管理',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/market/appManage/schoolSignUp'], resolve),
  },
  {
    path: '/market/appManage/feedback',
    name: 'market_feedback',
    meta: {
      title: '意见反馈',
      pageId: 'feedback',
      pageName: '意见反馈',
      parentId: 'appManage',
      parentName: 'APP管理',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/market/appManage/feedback'], resolve),
  },
  {
    path: '/market/appManage/bannerManage',
    name: 'market_bannerManage',
    meta: {
      title: 'Banner管理',
      pageId: 'bannerManage',
      pageName: 'Banner管理',
      parentId: 'appManage',
      parentName: 'APP管理',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/market/appManage/bannerManage'], resolve),
  },
  {
    path: '/market/appManage/openScreenPage',
    name: 'market_openScreenPage',
    meta: {
      title: '开屏页',
      pageId: 'openScreenPage',
      pageName: '开屏页',
      parentId: 'appManage',
      parentName: 'APP管理',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/market/appManage/openScreenPage'], resolve),
  },
  {
    path: '/market/appManage/frontPageManage',
    name: 'market_frontPageManage',
    meta: {
      title: '首页管理',
      pageId: 'frontPageManage',
      pageName: '首页管理',
      parentId: 'appManage',
      parentName: 'APP管理',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/market/appManage/frontPageManage'], resolve),
  },
  {
    path: '/market/appManage/themeManage',
    name: 'market_themeManage',
    meta: {
      title: '主题管理',
      pageId: 'themeManage',
      pageName: '主题管理',
      parentId: 'appManage',
      parentName: 'APP管理',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/market/appManage/themeManage'], resolve),
  },
  {
    path: '/market/appManage/medalManage',
    name: 'market_medalManage',
    meta: {
      title: '勋章管理',
      pageId: 'medalManage',
      pageName: '勋章管理',
      parentId: 'appManage',
      parentName: 'APP管理',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/market/appManage/medalManage'], resolve),
  },
  {
    path: '/market/appManage/noviceHelp',
    name: 'market_noviceHelp',
    meta: {
      title: '新手帮助',
      pageId: 'noviceHelp',
      pageName: '新手帮助',
      parentId: 'appManage',
      parentName: 'APP管理',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/market/appManage/noviceHelp'], resolve),
  },
  {
    path: '/market/appManage/agreementManage',
    name: 'market_agreementManage',
    meta: {
      title: '协议管理',
      pageId: 'agreementManage',
      pageName: '协议管理',
      parentId: 'appManage',
      parentName: 'APP管理',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/market/appManage/agreementManage'], resolve),
  },
  {
    path: '/market/appManage/ruleManage',
    name: 'market_ruleManage',
    meta: {
      title: '规则管理',
      pageId: 'ruleManage',
      pageName: '规则管理',
      parentId: 'appManage',
      parentName: 'APP管理',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/market/appManage/ruleManage'], resolve),
  },
  {
    path: '/market/appManage/virtualTask',
    name: 'market_virtualTask',
    meta: {
      title: '虚拟任务',
      pageId: 'virtualTask',
      pageName: '虚拟任务',
      parentId: 'appManage',
      parentName: 'APP管理',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/market/appManage/virtualTask'], resolve),
  },
  /*************培训管理**************************************/
  {
    path: '/market/trainManage/contentManage',
    name: 'market_contentManage',
    meta: {
      title: '内容管理',
      pageId: 'contentManage',
      pageName: '内容管理',
      parentId: 'trainManage',
      parentName: '培训管理',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/market/trainManage/contentManage'], resolve),
  },
  {
    path: '/market/trainManage/contentLabel',
    name: 'market_contentLabel',
    meta: {
      title: '内容标签',
      pageId: 'contentLabel',
      pageName: '内容标签',
      parentId: 'trainManage',
      parentName: '培训管理',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/market/trainManage/contentLabel'], resolve),
  },
  {
    path: '/market/trainManage/tabManage',
    name: 'market_tabManage',
    meta: {
      title: 'Tab管理',
      pageId: 'tabManage',
      pageName: 'Tab管理',
      parentId: 'trainManage',
      parentName: '培训管理',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/market/trainManage/tabManage'], resolve),
  },
  {
    path: '/market/trainManage/examinationManage',
    name: 'market_examinationManage',
    meta: {
      title: '考题管理',
      pageId: 'examinationManage',
      pageName: '考题管理',
      parentId: 'trainManage',
      parentName: '培训管理',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/market/trainManage/examinationManage'], resolve),
  },
  {
    path: '/market/trainManage/everyDayExamine',
    name: 'market_everyDayExamine',
    meta: {
      title: '每日一题',
      pageId: 'everyDayExamine',
      pageName: '每日一题',
      parentId: 'trainManage',
      parentName: '培训管理',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/market/trainManage/everyDayExamine'], resolve),
  },
  {
    path: '/market/trainManage/courseManage',
    name: 'market_courseManage',
    meta: {
      title: '课程管理',
      pageId: 'courseManage',
      pageName: '课程管理',
      parentId: 'trainManage',
      parentName: '培训管理',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/market/trainManage/courseManage'], resolve),
  },
  {
    path: '/market/trainManage/certificateManage',
    name: 'market_certificateManage',
    meta: {
      title: '证书管理',
      pageId: 'certificateManage',
      pageName: '证书管理',
      parentId: 'trainManage',
      parentName: '培训管理',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/market/trainManage/certificateManage'], resolve),
  },
  /*************官网管理**************************************/
  // {
  //   path: '/market/officialManage/officialNotice',
  //   name: 'market_officialNotice',
  //   meta: {
  //     title: '官网公告',
  //     pageId: 'officialNotice',
  //     pageName: '官网公告',
  //     parentId: 'officialManage',
  //     parentName: '官网管理',
  //     pageLayer: 3,
  //   },
  //   component: resolve => require(['@/views/market/officialManage/officialNotice'], resolve),
  // },
  // {
  //   path: '/market/officialManage/officialBrand',
  //   name: 'market_officialBrand',
  //   meta: {
  //     title: '官网品牌',
  //     pageId: 'officialBrand',
  //     pageName: '官网品牌',
  //     parentId: 'officialManage',
  //     parentName: '官网管理',
  //     pageLayer: 3,
  //   },
  //   component: resolve => require(['@/views/market/officialManage/officialBrand'], resolve),
  // },
  {
    path: '/market/officialManage/leavingMessage',
    name: 'market_leavingMessage',
    meta: {
      title: '官网留言板',
      pageId: 'leavingMessage',
      pageName: '官网留言板',
      parentId: 'officialManage',
      parentName: '官网管理',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/market/officialManage/leavingMessage'], resolve),
  },
  {
    path: '/market/officialManage/knowledgeBase',
    name: 'market_knowledgeBase',
    meta: {
      title: '官网知识库',
      pageId: 'knowledgeBase',
      pageName: '官网知识库',
      parentId: 'officialManage',
      parentName: '官网管理',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/market/officialManage/knowledgeBase'], resolve),
  },
  /*************B端管理**************************************/
  {
    path: '/market/bPlatformManage/bPlatformHelp',
    name: 'market_bPlatformHelp',
    meta: {
      title: 'B端帮助',
      pageId: 'bPlatformHelp',
      pageName: 'B端帮助',
      parentId: 'bPlatformManage',
      parentName: 'B端管理',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/market/bPlatformManage/bPlatformHelp'], resolve),
  },
  {
    path: '/market/bPlatformManage/bUpdateRecord',
    name: 'market_bUpdateRecord',
    meta: {
      title: 'B端更新记录',
      pageId: 'bUpdateRecord',
      pageName: 'B端更新记录',
      parentId: 'bPlatformManage',
      parentName: 'B端管理',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/market/bPlatformManage/bUpdateRecord'], resolve),
  },
  {
    path: '/market/bPlatformManage/requireFeedback',
    name: 'market_requireFeedback',
    meta: {
      title: 'B端需求',
      pageId: 'requireFeedback',
      pageName: 'B端需求',
      parentId: 'bPlatformManage',
      parentName: 'B端管理',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/market/bPlatformManage/requireFeedback'], resolve),
  },
  /*************邀请管理**************************************/
  {
    path: '/market/inviteManage',
    name: 'market_inviteManage',
    meta: {
      title: '邀请管理',
      pageId: 'inviteManage',
      pageName: '邀请管理',
      parentId: 'market',
      parentName: '市场',
      pageLayer: 2,
    },
    component: resolve => require(['@/views/market/inviteManage/inviteManage'], resolve),
  },
  /*************p端管理**************************************/
  {
    path: '/market/pPlatformManage/pPlatformHelp',
    name: 'market_pPlatformHelp',
    meta: {
      title: 'P端帮助',
      pageId: 'pPlatformHelp',
      pageName: 'P端帮助',
      parentId: 'pPlatformManage',
      parentName: 'p端管理',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/market/pPlatformManage/pPlatformHelp'], resolve),
  },
  {
    path: '/market/pPlatformManage/updateRecord',
    name: 'market_updateRecord',
    meta: {
      title: '更新记录',
      pageId: 'updateRecord',
      pageName: '更新记录',
      parentId: 'pPlatformManage',
      parentName: 'p端管理',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/market/pPlatformManage/updateRecord'], resolve),
  },
  /*************小程序管理**************************************/
  {
    path: '/market/appletManage/homeManage',
    name: 'market_homeManage',
    meta: {
      title: '首页管理',
      pageId: 'homeManage',
      pageName: '首页管理',
      parentId: 'appletManage',
      parentName: '小程序管理',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/market/appletManage/homeManage'], resolve),
  },
  /*************弹窗管理**************************************/
  {
    path: '/market/popupManage',
    name: 'market_popupManage',
    meta: {
      title: '弹窗管理',
      pageId: 'popupManage',
      pageName: '弹窗管理',
      parentId: 'market',
      parentName: '市场',
      pageLayer: 2,
    },
    component: resolve => require(['@/views/market/popupManage/popupManage'], resolve),
  },
];
